
































































































import { Component, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { DataModules } from "@/store/modules/data";
import { ITag } from "@/models/tags";
import TagsProvider from "@/components/app/global/tags/tagsProvider.vue";
import { ValidationObserver } from "vee-validate/dist/types/components/Observer.d";

@Component({
  components: {
    TagsProvider
  }
})
export default class TagsManageModal extends Mixins(HasValidation) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    tagsProvider: TagsProvider;
  };

  public isProcessing = false;

  public changed = false;

  public beforeDestroy() {
    if (this.changed) {
      this.$emit("update");
    }
  }

  // Methods
  public addTag() {
    this.$store
      .dispatch(`data/${DataModules.TAGS}/openAddEditModal`, {})
      .then(() => {
        this.changed = true;
        this.$refs.tagsProvider.reloadData();
        // this.getTags(true);
      })
      .catch(error => {
        this.$store.dispatch("api/handleError", error);
      });
  }

  public async confirmDelete(tag: ITag) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t(`_sentence.delete_confirmation`, {
            object: this.$t("_.tag")
          })
        },
        events: {
          confirmed: async () => {
            await this.deleteTag(tag);
            confirm.close();
          }
        }
      }
    });
  }

  public deleteTag(tag: ITag) {
    this.isProcessing = true;
    this.$store
      .dispatch(`data/${DataModules.TAGS}/remove`, {
        id: tag.id
      })
      .then(() => {
        // this.getTags(true);
        this.isProcessing = false;
        this.changed = true;
        this.$emit("delete", tag);
      })
      .catch(error => {
        this.isProcessing = false;
        this.$store.dispatch("api/handleError", error);
      });
  }

  public openEditModal(tag) {
    this.$store
      .dispatch(`data/${DataModules.TAGS}/openAddEditModal`, {
        tag
      })
      .then(() => {
        this.changed = true;
        this.$refs.tagsProvider.reloadData();
        // this.getTags(true);
      })
      .catch(error => {
        this.$store.dispatch("api/handleError", error);
      });
  }
}
